import { Modal, Stack, Form, Button } from "react-bootstrap";
import React from "react";
import eliminar_almacen_empaque from "../funciones/eliminar_almacen_empaque";


function ModalEliminar_empaque({
  Modal_eliminar,
  setModal_eliminar,
  actualizar_botones,
  Botones_campo,
}) {


  function eliminarProductoModal() {
    //obtener infor del formulario
    const valor = document.getElementById("categoria").value;
    // enviar informacion a firebase
    const infoProducto = {valor};
    eliminar_almacen_empaque(infoProducto);
    // cerrar modal
    actualizar_botones();
    setModal_eliminar(false); 
  }
 
  return (
    <Modal show={Modal_eliminar} onHide={() => setModal_eliminar(false)}>
      <Modal.Header>
        <Modal.Title>Eliminar botón de almacen empaque</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Stack>
            <h6>Seleccionar botón a eliminar</h6>
            <select id="categoria" type="text">
            {Botones_campo.map((datos,index)=>( 
                <option key={index}>{datos.valor}</option>
            ))}
            </select>
            
          </Stack>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setModal_eliminar(false)}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={()=>eliminarProductoModal()}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalEliminar_empaque;